import { useFormContext, get } from "react-hook-form";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/utils/cn";

export const AvailabilityBadges = ({
    enabled,
    times,
    dates,
    day,
    mobile = false,
    exception = false,
}) => {
    const {
        formState: { errors },
    } = useFormContext();
    const hasError = get(errors, `${day}`);

    const badgeClass = cn(
        "max-w-fit",
        !mobile && "hidden md:block",
        hasError && "hidden!",
    );

    if (hasError) {
        return (
            <Badge
                variant="danger"
                className={cn(!mobile && "hidden md:block")}
            >
                Please complete or remove invalid slots
            </Badge>
        );
    }

    if (!enabled) {
        return (
            <Badge variant="light" className={cn(mobile && "hidden md:block")}>
                {exception ? "Disabled" : "Closed"}
            </Badge>
        );
    }

    if (dates) {
        if (!dates?.startDate || !dates?.endDate) {
            return (
                <Badge variant="warning" className={badgeClass}>
                    Please select a start and end date
                </Badge>
            );
        }
    }

    if (dates?.allDay) {
        return (
            <Badge variant="success" className={badgeClass}>
                All Day
            </Badge>
        );
    }

    if (times?.length) {
        const validTimes = times.filter(
            (time) => time.startTime && time.endTime,
        );

        if (validTimes.length) {
            return validTimes.map((time, index) => (
                <Badge key={index} variant="success" className={badgeClass}>
                    {time.startTime} - {time.endTime}
                </Badge>
            ));
        }
    }

    return (
        <Badge variant="warning" className={badgeClass}>
            Please add a time slot
        </Badge>
    );
};
